export default __webpack_public_path__ + "static/media/not-ok4.6cc78714.png";